/** Cliente HTTP unico. Toda chamada passa por aqui para que erro de validacao,
 *  sessao expirada e falha de rede tenham sempre o mesmo formato na tela. */

export class ErroApi extends Error {
  constructor(
    readonly status: number,
    message: string,
    readonly campos: Record<string, string> = {},
  ) {
    super(message);
  }
  /** true quando o erro pertence a um campo do formulario, nao a tela toda. */
  get temCampos() {
    return Object.keys(this.campos).length > 0;
  }
}

type Opcoes = { metodo?: string; corpo?: unknown; sinal?: AbortSignal };

async function pedir<T>(caminho: string, { metodo = 'GET', corpo, sinal }: Opcoes = {}): Promise<T> {
  let resposta: Response;
  try {
    resposta = await fetch(`/api${caminho}`, {
      method: metodo,
      credentials: 'same-origin',
      signal: sinal,
      headers: corpo ? { 'Content-Type': 'application/json' } : undefined,
      body: corpo ? JSON.stringify(corpo) : undefined,
    });
  } catch {
    throw new ErroApi(0, 'Sem conexao com o servidor. Verifique a rede e tente de novo.');
  }

  if (resposta.status === 204) return undefined as T;

  const texto = await resposta.text();
  const dados = texto ? (JSON.parse(texto) as unknown) : null;

  if (!resposta.ok) {
    const d = (dados ?? {}) as { erro?: string; campos?: Record<string, string> };
    throw new ErroApi(resposta.status, d.erro ?? 'Nao foi possivel concluir.', d.campos ?? {});
  }
  return dados as T;
}

export const api = {
  get: <T>(caminho: string, sinal?: AbortSignal) => pedir<T>(caminho, { sinal }),
  post: <T>(caminho: string, corpo?: unknown) => pedir<T>(caminho, { metodo: 'POST', corpo }),
  put: <T>(caminho: string, corpo?: unknown) => pedir<T>(caminho, { metodo: 'PUT', corpo }),
  apagar: <T>(caminho: string) => pedir<T>(caminho, { metodo: 'DELETE' }),
};

/** Monta querystring ignorando vazios, para as URLs de lista ficarem limpas. */
export function query(params: Record<string, string | number | undefined>): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== '' && v !== null) p.set(k, String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : '';
}
